/*
 * New Race bookshop sections: shared AJAX add-to-cart for any form marked
 * [data-bp-add]. Loaded once from layout/theme.liquid.
 *
 * Hands the result to Dawn's own cart UI (cart drawer or cart notification) so
 * quick-add behaves exactly like the product page: drawer opens, the header
 * bubble updates, and other Dawn components hear the cartUpdate event.
 * A "Buy it now" button (name="checkout") skips AJAX and goes straight to checkout.
 */
(function () {
  if (window.bpCart) return;
  window.bpCart = true;

  var routes = window.routes || {};
  var addUrl = routes.cart_add_url || '/cart/add';
  var cartUrl = routes.cart_url || '/cart';

  function toast(message, isError) {
    var t = document.createElement('div');
    t.className = 'bp-toast' + (isError ? ' is-err' : '');
    t.setAttribute('role', isError ? 'alert' : 'status');
    t.textContent = message;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('on'); });
    setTimeout(function () {
      t.classList.remove('on');
      setTimeout(function () { t.remove(); }, 300);
    }, 2800);
  }

  function getCartUi() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-bp-add]')) return;

    // Buy it now: add the item, then land on checkout (native POST, works without JS too).
    if (event.submitter && event.submitter.name === 'checkout') {
      var returnTo = form.querySelector('input[name="return_to"]');
      if (!returnTo) {
        returnTo = document.createElement('input');
        returnTo.type = 'hidden';
        returnTo.name = 'return_to';
        form.appendChild(returnTo);
      }
      returnTo.value = '/checkout';
      return;
    }

    event.preventDefault();
    var button = form.querySelector('button[name="add"]') || form.querySelector('button[type="submit"]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    var cart = getCartUi();
    var body = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body,
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          toast(response.description || response.message || (window.cartStrings && window.cartStrings.error) || 'Could not add to cart', true);
          return;
        }
        if (!cart) {
          window.location = cartUrl;
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bp-quick-add', productVariantId: body.get('id'), cartData: response });
        }
        cart.classList.remove('is-empty');
        cart.renderContents(response);
      })
      .catch(function () {
        toast((window.cartStrings && window.cartStrings.error) || 'Could not add to cart', true);
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      });
  });
})();
